export interface PanelLayoutProps {
  children: React.ReactNode;
  panel2?: React.ReactNode | undefined;
  panel3?: React.ReactNode | undefined;
  panel3Width?: number | undefined;
  showDetail?: boolean | undefined;
  className?: string;
}

export function PanelLayout({ children, panel2, panel3, panel3Width, showDetail, className = '' }: PanelLayoutProps) {
  return (
    <div className={`flex flex-col @md:flex-row @lg:flex-row h-full min-h-0 bg-sd-background ${className}`.trim()}>
      {/* Panel 1 - list panel; hidden on mobile when showDetail=true */}
      <div className={`${showDetail ? 'hidden' : 'block'} @md:block w-full @md:w-[280px] @lg:w-[300px] @lg:min-w-[300px] @md:border-r border-sd-border/20 shadow-[1px_0_3px_rgba(0,0,0,0.03)] overflow-y-auto min-h-0 transition-[opacity,transform] duration-200 ease-out motion-reduce:transition-none @md:transition-none`}>
        {children}
      </div>

      {/* Panel 2 - detail panel; hidden on mobile unless showDetail=true */}
      <div className={`${showDetail ? 'block' : 'hidden'} @md:block @md:flex-1 min-w-0 min-h-0 h-full`}>
        {panel2 ?? <div />}
      </div>

      {/* Panel 3 - visible on desktop only when content provided */}
      {panel3 != null && (
        <div
          className="hidden @lg:block flex-shrink-0"
          style={panel3Width != null ? { width: panel3Width } : { width: 280 }}
        >
          {panel3}
        </div>
      )}
    </div>
  );
}
